import React from 'react';
import {
  Button, Chip, CircularProgress, Stack,
} from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

import { RECOMMENDATION_RUN_STATUS } from './recommendationRunModel';

const copy = (t, key, defaultValue, options = {}) => t(key, { defaultValue, ...options });

/** Keep the FY-wide manual operation visible to Admin without repeating page context. */
export default function RecommendationRunStatus({
  canMutate, onRun, run, t,
}) {
  const noRun = run.status === RECOMMENDATION_RUN_STATUS.NO_RUN;
  const stale = run.status === RECOMMENDATION_RUN_STATUS.STALE;
  const updating = run.status === RECOMMENDATION_RUN_STATUS.UPDATING;
  if (!canMutate && !stale) return null;

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      spacing={1}
      useFlexGap
      flexWrap={'wrap'}
    >
      {stale && (
        <Chip
          color={'warning'}
          label={copy(t, 'climateAction.ai.inventoryUpdated', 'Inventory updated')}
          size={'small'}
          variant={'outlined'}
        />
      )}
      {canMutate && (
        <Button
          disabled={updating}
          onClick={onRun}
          size={'small'}
          startIcon={updating
            ? <CircularProgress color={'inherit'} size={15} />
            : noRun ? <AutoAwesomeOutlinedIcon /> : <RefreshRoundedIcon />}
          variant={'outlined'}
        >
          {updating
            ? t('common.updating')
            : copy(
              t,
              noRun ? 'climateAction.ai.generateRecommendations' : 'climateAction.ai.regenerateRecommendations',
              noRun ? 'Generate recommendations' : 'Regenerate recommendations',
            )}
        </Button>
      )}
    </Stack>
  );
}
